import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { initialize } from 'src/actions/help';
import CommonHelp from 'src/components/CommonHelp';
import { IRootState } from 'src/reducers';

/**
 * 受講者ヘルプ
 */
export const CMHelps = connect(
	(state: IRootState) => ({
		guides: state.help.participantCM,
	}),
	(dispatch: Dispatch) => ({
		init() {
			dispatch(initialize());
		},
	})
)(CommonHelp);



// WEBPACK FOOTER //
// ./src/containers/CMHelps.tsx